import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const GeologiaShapeFileCavernas = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default GeologiaShapeFileCavernas;